import React from "react";
import { classNames, responsiveClassNames } from "../../utilities/helpers.js";
import s from "./Hidden.module.css";
const Hidden = (props) => {
    const { as: TagName = "div", children, visibility, hide, displayStyle } = props;
    const rootClassNames = classNames(s.root, ...responsiveClassNames(s, "--hidden", hide), visibility && s["--visibility"], displayStyle && s[`--display-${displayStyle}`]);
    if (typeof children === "function")
        return React.createElement(React.Fragment, null, children(rootClassNames));
    return React.createElement(TagName, { className: rootClassNames }, children);
};
export default Hidden;
